import styled from "styled-components";
import { Row } from "../../globalStyles";
import { ContentImage } from "../Contents/ContentStyles";

export const FooterContainer = styled.div`
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.35);
  display: grid;
  align-items: center;
  justify-items: center;
  position: static;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  padding: 0 10vw;
`;

export const FooterLogo = styled.a`
  padding: 0;
  cursor: pointer;
  margin-bottom: ${({ mb }) => (mb ? mb : "-30px")};
  margin-top: ${({ mt }) => (mt ? mt : "30px")};

  &:hover {
    transform: rotate(1deg) scale(105%);
  }

  @media screen and (max-width: 1280px) {
    left: 15vw;
  }
`;

export const FooterIcon = styled.img`
  max-width: 250px;
  margin-right: 10px;

  @media screen and (max-width: 1024px) {
    max-width: 200px;
  }
`;

export const FooterRow = styled(Row)`
  justify-content: space-around;

  @media screen and (max-width: 1024px) {
    width: 95%;
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    width: 50%;
    margin-top: 20px;
  }
`;

export const FooterImageRow = styled(FooterRow)`
    display: grid;
    grid-template-columns: auto auto auto;
    @media (max-width: 1600px) {
        grid-template-columns: auto auto;
`;

export const FooterImage = styled(ContentImage)`
  @media screen and (max-width: 1024px) {
    width: 4rem;
  }
`;

export const FooterTextWrapper = styled.a`
  color: white;
  text-shadow: 1px 1px #222;
  font-size: clamp(0.8rem, 0.9rem, 1rem);
  font-weight: 700;
  padding: 2px;
  cursor: pointer;
  text-decoration: none;
  margin: 2px 0;

  ::before {
    white-space: pre;
    content: " ";
  }
`;

export const FooterInfoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: start;
  font-family: "Arial", sans-serif;
  font-size: 0.9rem;
  color: #eee;

  @media (max-width: 768px) {
    gap: 1.5rem;
  }
`;

export const FooterIconWrapper = styled.div`
  display: flex;
  align-items: flex-start; /* Align icon to top of text */
  min-width: 24px; /* Consistent width for icons */
  margin-top: 0.1rem; /* Slight offset to visually center with text cap height */
`;

export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem; /* Space between rows */
  width: auto;

  /* Removed justify-content/align-self as Grid handles positioning */
`;
